import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, AuthContext } from "../App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import React from "react";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error("Please enter both username and password");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, { username: username.trim(), password });
      login(response.data.token, response.data.user);
      toast.success("Login successful!");
      navigate("/");
    } catch (error) {
      const status = error.response?.status;
      const detail = error.response?.data?.detail;
      if (status === 401) {
        toast.error(detail || "Invalid credentials — check username and password");
      } else if (!error.response) {
        toast.error("Network error — please check your connection and try again");
      } else {
        toast.error(detail || "Login failed — please try again");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1B3A5C] px-4 py-6">
      <div className="w-full max-w-md p-4 sm:p-8">
        <div className="text-center mb-6 sm:mb-8">
          <img src="/swami-icon.png" alt="Swami Software PT" className="h-14 sm:h-16 mx-auto mb-4 rounded-xl shadow-lg" />
          <h1 className="text-2xl sm:text-3xl font-black text-white" style={{fontFamily: 'Chivo'}}>Swami Software PT</h1>
          <p className="text-xs sm:text-sm text-gray-400 mt-1">Manufacturing ERP</p>
        </div>
        <div className="bg-white rounded-xl p-5 sm:p-8 shadow-2xl">
          <h2 className="text-xl font-bold text-[#0F172A] mb-6" style={{fontFamily: 'Chivo'}}>Sign In</h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-sm font-semibold text-[#1D2951]">Username</Label>
              <Input data-testid="login-username-input" type="text" value={username}
                onChange={(e) => setUsername(e.target.value)} required className="min-h-[48px] rounded-lg" placeholder="Enter username" />
            </div>
            <div className="space-y-2">
              <Label className="text-sm font-semibold text-[#1D2951]">Password</Label>
              <Input data-testid="login-password-input" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} required className="min-h-[48px] rounded-lg" placeholder="Enter password" />
            </div>
            <Button type="submit" data-testid="login-submit-button" disabled={loading}
              className="w-full min-h-[48px] bg-[#1D2951] hover:bg-[#2A3B73] text-white font-semibold rounded-lg text-base">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
        <p className="text-center text-gray-500 text-xs mt-6">Swami Software PT &copy; {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}

export default Login;
